import { computed } from 'vue';
import type { RouteMeta, RouteParams } from 'vue-router';
import { useRoute } from 'vue-router';

import type { LayoutModel } from '@/shared/layouts/base/models';

type LayoutEntry = (params: RouteParams) => LayoutModel;

type Entry = LayoutEntry | LayoutModel;

type MetaLayout = RouteMeta & {
  [key]?: LayoutEntry;
};

const key = 'layout-meta';

export function useLayoutMeta(entry: Entry): MetaLayout {
  return {
    [key]: (params: RouteParams) => {
      return entry instanceof Function ? entry(params) : entry;
    },
  };
}

export function useRouterLayout() {
  const route = useRoute();

  const layout = computed(() => {
    const layoutMeta = route.meta[key] as LayoutEntry | undefined;

    if (!layoutMeta) {
      return undefined;
    }

    return layoutMeta(route.params);
  });

  const hideSidebar = computed(() => {
    return layout.value?.hideSidebar ?? false;
  });

  return { layout, hideSidebar };
}
